import {
    ChangeDetectionStrategy,
    Component,
    Input,
} from '@angular/core';

export enum LogoScope {
    Navbar,
    LoginForm,
}

@Component({
    selector: 'ui-logo',
    templateUrl: 'ui-logo.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiPathLogoComponent {
    public LogoScope = LogoScope;

    @Input()
    public width!: number;
    @Input()
    public height!: number;
    @Input()
    public collapsed?: boolean;
    @Input()
    public set scope(value: keyof typeof LogoScope) {
        if (!LogoScope[value]) {
            const logoScopeOptions = Object.keys(LogoScope)
                .filter((o: any) => isNaN(o))
                .join(', ');

            throw new Error(`'${value}' is an invalid scope. Available options: ${logoScopeOptions}.`);
        }

        this._scope = value;
    }

    public get scope() {
        return this._scope!;
    }

    private _scope?: keyof typeof LogoScope;

    constructor() {
    }

    getWidth() {
        return this.width + 'px';
    }

    getHeight() {
        return this.height + 'px';
    }
}
